import { StyleModel } from "./style.model";

export class StyleTargetEffRequest {
    unitId: string;
    styles: StyleModel[];

    constructor(unitId: string, styles: StyleModel[]) {
        this.unitId = unitId;
        this.styles = styles;
    }
}